import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { SingleLineTruncate } from '../../../../../components/LineTruncate';
import TruncateTextWithButton from '../../buttons/TruncateTextWithButton';
import css from './ServiceCard.module.scss';
import { RSButtonLink } from 'src/reservation-page/RSButtonLink';

interface Props {
  className?: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  pageUrl?: string;
}

const ServiceCard = ({
  className,
  title,
  description,
  thumbnailUrl,
  pageUrl,
}: Props) => {
  const intl = useIntl();
  return (
    <div className={classNames(css.ServiceCard, className)}>
      {thumbnailUrl && (
        <div className={css.ServiceCard__Thumbnail}>
          <div
            className={css.ServiceCard__ThumbnailImage}
            style={{ backgroundImage: `url(${thumbnailUrl})` }}
          />
        </div>
      )}
      <div className={css.ServiceCard__Heading}>
        <SingleLineTruncate maxLine={2} text={title} />
      </div>
      <div className={css.ServiceCard__Description}>
        <TruncateTextWithButton
          className={css.ServiceCard__TruncateTextWithButton}
          text={description}
          maxLine={3}
        />
        {pageUrl && (
          <div className="flex justify-end">
            <div className="w-[128px]">
              <RSButtonLink
                variant="outline"
                isBlock
                href={pageUrl}
                prefetch={false}
              >
                {intl.formatMessage({
                  id: 'merchants.common.serviceCard.pageLink',
                })}
              </RSButtonLink>
            </div>
          </div>
        )}
      </div>
      <div className={css.ServiceCard__Clearfix} />
    </div>
  );
};

export default ServiceCard;
